module.exports = __webpack_public_path__ + "packs/media/images/brand_solo-8666b36fa0034f63bf32b698c9c8e7dd.png";